import { Component, Input } from '@angular/core';
import { OrderDetails } from '../../../models/orders/orderDetails';
import { TransactionType } from '../../../core/constants';
import { Customer } from '../../../models/customer/customer';
import { PaymentMethod } from '../../../models/paymentMethod/paymentMethod';
import { StreetAddress } from '../../../models/streetAddress/streetAddress';
import { UIHelpers } from '../../../core/ui-helpers';
import { EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-terminal-summary',
  templateUrl: './terminal-summary-component.html',
  standalone: false,
})
export class TerminalSummaryComponent {

  @Input() orderDetails: OrderDetails | undefined;
  @Input() selectedTransactionFriendlyName: string = "";
  @Input() selectedCustomer: Customer | undefined;
  @Input() selectedPaymentMethod: PaymentMethod | undefined;
  @Input() readyToSubmit: boolean = false;
  @Input() shippingAddress: StreetAddress | undefined;
  @Input() amountToTransact: number = 0;

  @Output() onSubmit = new EventEmitter<void>();


  amountToTransactFormatted: string = "";
  TransactionType = TransactionType;

  constructor() {
    this.selectedTransactionFriendlyName = "";
  }

  ngOnInit(): void {
    if (this.orderDetails && this.orderDetails.transactionType) {
      this.selectedTransactionFriendlyName = this.orderDetails.transactionType == TransactionType.TRANSACTION_TYPE_RECUR ? "Recurring" : "One-time";
    }
  }

  btnCompleteTransaction_click() {
    console.log("btnCompleteTransaction_click");
  }

  getPaymentMethodName(): string {
    //return this.selectedPaymentMethod.paymentMethodType == PaymentMethodType.PAYMENT_METHOD_TYPE_CARD ? "Card" : "Bank Account";
    return "";
  }

  formIsComplete(): boolean {
    return true;
  }

  formIsBeingSubmitted(): boolean {
    return false;
  }

  formatPhone(val: string, ccCode: string) {
    return UIHelpers.formatPhone(val, ccCode);
  }
  
  getTransactionTypeFriendlyName(): string {

    switch (Number(this.orderDetails?.transactionType)) {
      case TransactionType.TRANSACTION_TYPE_AUTH:
        return 'Authorization';
      case TransactionType.TRANSACTION_TYPE_AUTHCAPTURE:
        return 'Sale';
      case TransactionType.TRANSACTION_TYPE_CAPTURE:
        return 'Capture';
      case TransactionType.TRANSACTION_TYPE_RECUR:
        return 'Recurring charge';
      case TransactionType.TRANSACTION_TYPE_REFUND:
        return 'Refund';
      case TransactionType.TRANSACTION_TYPE_REVERSAL:
        return 'Reversal';
      case TransactionType.TRANSACTION_TYPE_VOID:
        return 'Void';
      default:
        return '';
    }
  }

  getOrderTotalFormatted(): string {
    return this.amountToTransactFormatted = UIHelpers.formatCurrency(this.orderDetails?.totalAmount,);
  }
}
